import { Injectable } from "@angular/core";
import { AppConfigService } from "src/app/core/app-config/app-config.service";
import { HttpClient } from "@angular/common/http";
import { TranslationsResponse } from "../models/Translation";
import { BaseService } from "./base.service";
 
@Injectable({
    providedIn: 'root'
  })
  export class BabelService extends BaseService{
    appConfigService: AppConfigService;
    constructor(
      httpClient: HttpClient,
      appConfigService: AppConfigService) {
      super(httpClient, appConfigService.configuration.apiConfig.babelServiceBaseUrl);
      this.appConfigService = appConfigService;
    }
 
    async getTranslations(){
      const application = this.appConfigService.configuration.application;
      const apiUrl = `client/translations/${application}`;
      const translationResponse = await this.get<TranslationsResponse>(apiUrl).toPromise();
      for(let i =0; i<translationResponse.translations.length;i++){
        const currentTranslation = translationResponse.translations[i];
        let label : Record<string, string> = {};
        for(let j=0;j<currentTranslation.labels.length;j++){
          label[currentTranslation.labels[j].code] = currentTranslation.labels[j].text;
        }
        sessionStorage.setItem(translationResponse.translations[i].languageCode, JSON.stringify(label));
        if(translationResponse.translations[i].languageCode == sessionStorage.getItem('LanguageCode')){
          document.title = label['vbeiEFCTOrdering'];
          localStorage.setItem('termsAndCondition', label['vbeiTermsAndConditionsContent']);
          localStorage.setItem('GeneralTnCheading', label['vbeiGeneralTnC']);
          localStorage.setItem('GuidedOrdering', label['vbeiEFCTOrdering']);
        }
      }
    }

    static getListOfTranslationsForUserLanguage()
    {
      var language = sessionStorage.getItem('LanguageCode');
      if(language === undefined || language === null ){
        language = "en";
    }
      return JSON.parse(sessionStorage.getItem(language));
    }

    static translate(value: string): string {
      const translations = BabelService.getListOfTranslationsForUserLanguage();
      const browserTranslation = JSON.parse(sessionStorage.getItem(navigator.language.split('-')[0]));
      if (!translations) {
        return browserTranslation ? browserTranslation : value;
      }  
     
      let res = translations[value] ? translations[value] : (browserTranslation ?  browserTranslation : value);
      return typeof(res) === 'object' ? value : res;
    }
}